import { useCallback } from "react";
import { Accordion, Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function FAQ() {
  const navigate = useNavigate();

  const handleSupportNavigate = useCallback(() => {
    navigate("/contattaci");
  }, [navigate]);

  return (
    <Container
      fluid
      className="d-flex flex-column gap-3 py-5 justify-content-center align-items-center"
    >
      <h2 className="text-center mb-4">Domande Frequenti (FAQ)</h2>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            Come posso cancellare il mio account?
          </Accordion.Header>
          <Accordion.Body>
            Ci dispiace moltissimo che tu abbia deciso di cancellare la tua
            iscrizione a GetMove! Puoi cancellare il tuo Account dalla Sezione
            Profilo - Elimina Account
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            Come posso recuperare la mia password?
          </Accordion.Header>
          <Accordion.Body>
            Per recuperare la tua password, contatta il nostro supporto clienti
            all'indirizzo support@getmoveapp.com.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            Come posso recuperare la mia password?
          </Accordion.Header>
          <Accordion.Body>
            Per recuperare la tua password, contatta il nostro supporto clienti
            all'indirizzo support@getmoveapp.com.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            Come posso aggiornare le informazioni del mio profilo?
          </Accordion.Header>
          <Accordion.Body>
            Puoi aggiornare il tuo profilo accedendo alla sezione "Dati
            Personali" nella sezione Profilo.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Button
        variant="success"
        style={{ width: "25%" }}
        onClick={handleSupportNavigate}
      >
        Contattaci
      </Button>
    </Container>
  );
}
